<template>
  <v-card>
    <v-card-title>Confirm Logout</v-card-title>
    <v-card-text>Are you sure you want to logout?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click="closeLogoutDialog">No</v-btn>
      <!-- Logout if user clicks yes -->
      <v-btn color="green darken-1" text @click="logout">Yes</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Logout",
  methods: {
    ...mapActions(["authenticateUser"]),
    closeLogoutDialog() {
      this.$emit("closeLogoutDialog");
    },
    async logout() {
      const loggedOut = await this.authenticateUser();
      if (loggedOut) {
        // console.log("logged out");

        this.closeLogoutDialog();

        // remove user details from store
        this.$store.state.fetchvigator.collection.user = {};
        // this.$router.push("/");
      }
    },
  },
};
</script>

<style></style>
